import { render, staticRenderFns } from "./TakeAwayMenuCartPanelProduct.vue?vue&type=template&id=45a1907e&"
import script from "./TakeAwayMenuCartPanelProduct.vue?vue&type=script&lang=ts&"
export * from "./TakeAwayMenuCartPanelProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports